export const SEVER_URL = process.env.REACT_APP_SEVER_URL;
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export const STORAGE_KEY_ACCESS_TOKEN = 'token';
